import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter, Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../_services/auth.service';
import { NavComponent } from '../../shared/components/nav/nav.component';
import { MobileHomeMenuComponent } from '../../shared/components/mobile-home-menu/mobile-home-menu.component';

@Component({
  selector: 'app-app-layout',
  standalone: true,
  imports: [RouterOutlet, NavComponent, MobileHomeMenuComponent],
  templateUrl: './app-layout.component.html',
})
export class AppLayoutComponent implements OnInit, OnDestroy {
  hideSidebar = false;
  private destroy$ = new Subject<void>();
  private currentRoute = '';
  private hideFromRouteData = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.destroy$)
    ).subscribe((event: NavigationEnd) => {
      let route = this.activatedRoute;
      while (route.firstChild) {
        route = route.firstChild;
      }
      const data = route.snapshot?.data ?? {};
      this.hideFromRouteData = !!data['hideSidebar'];
      this.currentRoute = event.urlAfterRedirects;
      this.updateSidebarVisibility();
    });
  }

  ngOnInit(): void {
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => this.updateSidebarVisibility());
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  logout(): void {
    this.authService.logout();
  }

  private isMobileView(): boolean {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < 768;
  }

  private isDocumentRoute(): boolean {
    return this.currentRoute.startsWith('/document/');
  }

  private updateSidebarVisibility(): void {
    const hideForMobileDocument = this.isDocumentRoute() && this.isMobileView();
    this.hideSidebar = this.hideFromRouteData || hideForMobileDocument;
  }
}
